import { render, staticRenderFns } from "./CopyDetail.vue?vue&type=template&id=fd9df2d2&scoped=true"
import script from "./CopyDetail.vue?vue&type=script&lang=js"
export * from "./CopyDetail.vue?vue&type=script&lang=js"
import style0 from "./CopyDetail.vue?vue&type=style&index=0&id=fd9df2d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9df2d2",
  null
  
)

export default component.exports